import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { waLink, WHATSAPP_NUMBER, ABSTRACT_BG } from "../lib/data";

export default function FinalCTA() {
  return (
    <section
      id="contacto"
      data-testid="final-cta-section"
      className="relative bg-[#0A0B0E] py-28 lg:py-40 overflow-hidden border-t border-white/5"
    >
      {/* bg */}
      <div className="absolute inset-0 opacity-25">
        <img src={ABSTRACT_BG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0B0E]/70 via-[#0A0B0E]/85 to-[#0A0B0E]" />
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="inline-flex items-center gap-4 mb-10 justify-center">
            <span className="w-10 h-px bg-[#D4AF37]" />
            <span className="text-[#D4AF37] text-xs uppercase tracking-[0.35em]">
              Cotización sin costo
            </span>
            <span className="w-10 h-px bg-[#D4AF37]" />
          </div>

          <h2 className="font-display text-5xl sm:text-6xl lg:text-8xl leading-[1] tracking-tighter text-white max-w-5xl mx-auto">
            ¿Listo para{" "}
            <span className="italic text-[#D4AF37]">proteger tu espacio</span>?
          </h2>

          <p className="mt-10 max-w-2xl mx-auto text-base lg:text-lg text-white/60 font-light leading-relaxed">
            Contáctanos hoy — vamos a tu ubicación en Querétaro, tomamos medidas y
            te damos una cotización detallada sin compromiso.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-5">
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-whatsapp-cta"
              className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-[#D4AF37] text-black font-medium hover:shadow-[0_0_50px_rgba(212,175,55,0.5)] transition-all"
            >
              <MessageCircle size={18} />
              Cotizar por WhatsApp: {WHATSAPP_NUMBER}
              <span className="transition-transform group-hover:translate-x-1">→</span>
            </a>
            <a
              href="tel:+5214423429535"
              data-testid="final-call-cta"
              className="inline-flex items-center gap-3 px-7 py-3.5 rounded-full border border-white/20 text-white hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all text-sm uppercase tracking-[0.2em]"
            >
              <Phone size={16} />
              Llamar ahora
            </a>
          </div>

          <div className="mt-14 text-sm text-white/40 font-light max-w-2xl mx-auto leading-relaxed">
            Atendemos toda la zona metropolitana de Querétaro · Envíanos tus
            medidas por WhatsApp · Respuesta en menos de 1 hora
          </div>
        </motion.div>
      </div>
    </section>
  );
}
